/* Lil Quiet World - single-copy buy button.

   The hero buy button is a normal Shopify add-to-cart form, so it keeps working
   with JavaScript disabled. The problem with a plain add-to-cart form on a
   one-product digital store is that every click stacks another copy, and the
   cart survives between visits - two clicks over two days charges twice.

   This rewires the button so each click empties the cart, adds exactly one
   copy, and goes straight to checkout. The variant id is read from the form's
   own hidden input, so nothing here needs to know the product.

   If any request fails, it falls back to submitting the form normally. */
(function () {
  'use strict';

  function wire(form) {
    var idField = form.querySelector('input[name="id"]');
    if (!idField || !idField.value) { return; }
    var variantId = idField.value;
    var busy = false;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) { return; }
      busy = true;

      var button = form.querySelector('button[type="submit"], button');
      if (button) { button.disabled = true; }

      var headers = { 'Content-Type': 'application/json' };

      fetch('/cart/clear.js', { method: 'POST', headers: headers })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function (response) {
          if (!response.ok) { throw new Error('add to cart failed'); }
          window.location.href = '/checkout';
        })
        .catch(function () {
          busy = false;
          if (button) { button.disabled = false; }
          form.submit();
        });
    });
  }

  function init() {
    if (!window.fetch) { return; }
    var form = document.getElementById('lqw-buy');
    if (form) { wire(form); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
